<template>
  <page-view>
    <contact-section :heading="$t('contact')"/>
    <map-section :heading="$t('mapHeading')"/>
    <links-section :heading="$t('linksHeading')" :links="links.items"/>
    <job-offers-section
      :heading="$t('jobHeading')"
      :description="jobDescription"
      :offers="jobs"
    />
  </page-view>
</template>

<script>
import store from '@/store'
import { mapGetters } from 'vuex'
import ContactSection from '@/containers/Contact/ContactSection'
import MapSection from '@/containers/Contact/MapSection'
import LinksSection from '@/containers/Contact/LinksSection'
import JobOffersSection from '@/containers/Contact/JobOffersSection'

export default {
  components: {
    ContactSection,
    MapSection,
    LinksSection,
    JobOffersSection
  },
  data () {
    return {
      job: {
        description: `SAWAWA przyjmuje na praktyki studentów architektury,
                      wyrózniajacych sie umiejetnoscia koncepcyjnego myslenia i
                      kreatywnym podejsciem do projektowych zadan. Stażysta
                      powinien wykazac sie takze umiejetnoscia pracy w zespole i
                      znajomoscia programów: AutoCAD, Adobe, Rhino.`
      },
      links: {
        items: [
          {
            title: 'facebook',
            href: 'https://www.facebook.com/pracowniasawawa'
          },
          {
            title: 'linkedin',
            href: 'https://www.linkedin.com/company/pracownia-sawawa/'
          }
        ]
      }
    }
  },
  computed: {
    ...mapGetters(['jobs', 'jobDescription'])
  },
  beforeRouteEnter (to, from, next) {
    store.dispatch('fetchJobDescription')
      .then(() => store.dispatch('fetchJobs'))
      .then(next)
      .catch(() => {
        next({ name: 'home' })
      })
  }
}
</script>



// WEBPACK FOOTER //
// src/containers/Contact/ContactContainer.vue